import {ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {CustomerCommentList} from '../../../react/customers/comments/customer-comment-list';
import {Customer} from '../model/customer';
import {ErrorBoundary} from '../../../react/errorhandling/ErrorBoundary';

const containerElementName = 'reactCustomerCommentList';

@Component({
  selector: 'customer-comment',
  template: `
    <customer-header-template [customer]="customer"></customer-header-template>
    <div class="w-full">
      <div #${containerElementName}></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CustomerCommentComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() customer: Customer;

  constructor() {
    super();
  }

  protected override renderComponent() {
    return <ErrorBoundary>
      <CustomerCommentList customerId={this.customer.id}/>
    </ErrorBoundary>;
  }
}
